import CoreTabBar from "../../../app/core/components/CoreTabBar/CoreTabBar";
import { useState } from "react";
import PlaygroundPage from "./Playground/PlaygroundPage";
import CategoriesPage from "./Categories/CategoriesPage";
import { t } from "i18next";
import CoreButtonHoverIcon from "../../../app/core/components/CoreButtonIcon/CoreButtonHoverIcon";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import LockOpenOutlinedIcon from "@mui/icons-material/LockOpenOutlined";
import { useSelector } from "react-redux";

const ExtendDocCategoriesPage = () => {
  const appConfig = useSelector((state) => state.app.appConfig);

  const TABS = [
    { label: t("Categories"), tab: "categories" },
    { label: t("Playground"), tab: "playground" },
  ];
  const [selectedTab, setSelectedTab] = useState("categories");
  const [active, setActive] = useState(false);

  return (
    <div className="w-full">
      <div className="flex justify-center items-center">
        <h2 style={{ width: "250px" }}>{t("ExtCategoriesShort")}</h2>
        <CoreTabBar tab={TABS} setSelectedTab={setSelectedTab} />
        {appConfig?.modules?.DEMO?.privacy && (
          <div className="w-6/12 flex justify-end">
            <CoreButtonHoverIcon
              onClick={() => setActive(!active)}
              className={`font-semibold m-1
              ${active ? "text-green-500 " : "text-darkgray "}`}
              testo={t("Anonimizzazione dati")}
              icon={
                active ? (
                  <LockOutlinedIcon className={`fill-green-500`} />
                ) : (
                  <LockOpenOutlinedIcon className={`fill-darkgray`} />
                )
              }
            />
          </div>
        )}
      </div>

      {selectedTab === "playground" ? <PlaygroundPage /> : <CategoriesPage />}
    </div>
  );
};

export default ExtendDocCategoriesPage;
